/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Content_Errors_OptionInputs */



/**
* | output |
* | --- |
* | "Content Errors" |
*
* @param {Error_Nav_Content_Errors_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_content_errors_option = /** @type {((inputs?: Error_Nav_Content_Errors_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Content_Errors_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreurs de contenu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhaltsfehler")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errori di contenuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибки содержимого")
	if (locale === "es") return /** @type {LocalizedString} */ ("Errores de contenido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("内容错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コンテンツエラー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामग्री त्रुटियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erros de conteúdo")
	return /** @type {LocalizedString} */ ("Content Errors")
});